"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var basic_table_component_1 = require("../../../basic-component/basic-table.component");
var universal_table_grid_1 = require("./universal-table.grid");
var universal_table_paste_1 = require("./universal-table.paste");
require('./universal-table.component.css');
var BG_RED = { 'background-color': universal_table_paste_1.ColorConfig.RED, 'color': 'black' };
var BG_GREEN = { 'background-color': universal_table_paste_1.ColorConfig.GREEN, 'color': 'black' };
var BG_BLUE = { 'background-color': universal_table_paste_1.ColorConfig.BLUE, 'color': 'black' };
function triggerResize() {
    $(window).trigger('resize');
}
function isIE() {
    var ua = navigator.userAgent;
    return ua.indexOf('Trident') > 0 ||
        navigator.userAgent.indexOf('MSIE') > 0;
}
function generateLegends(mainLegends, siblingLegends, rows) {
    var allTags = {};
    rows.forEach(function (row) {
        if (!allTags[row.colorTag]) {
            allTags[row.colorTag] = true;
        }
    });
    if (!siblingLegends) {
        siblingLegends = [];
    }
    return mainLegends.concat(siblingLegends).filter(function (x) { return allTags[x.tag]; });
}
var UniversalTableComponent = /** @class */ (function () {
    function UniversalTableComponent($scope, $timeout) {
        var ctrl = this;
        ctrl.colorConfig = universal_table_paste_1.ColorConfig;
        ctrl.$scope = $scope;
        ctrl.$timeout = $timeout;
        ctrl.editMode = false;
        ctrl.months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        ctrl.isIE = isIE();
        ctrl.loading = {
            start: function () {
                $scope.$emit('workbench:loading', { load: true });
            },
            end: function () {
                $scope.$emit('workbench:loading', { load: false });
            }
        };
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        ctrl.reloadTree = function (reload) {
            $scope.$emit('workbench:back', { reload: reload });
        };
        ctrl.lastUpdated = function () { return $scope.$emit('workbench:last_updated', { nodeID: ctrl.selectedNode._id }); };
        ctrl.updateNodeIsDataValid = function (changesToSave, failureList) {
            var failedNodeIdList = (failureList || []).map(function (i) { return i.nodeId; });
            var nodeIdList = changesToSave.filter(function (i) { return (failedNodeIdList.indexOf(i.id) < 0); }).map(function (i) { return i.id; });
            $scope.$emit('workbench:update_isDataValid', { nodeIdList: nodeIdList });
        };
        ctrl.updateCategories = function (categoryData, categoryType) { return $scope.$emit('workbench:update_categories', {
            data: categoryData,
            categoryType: categoryType || "tags"
        }); };
        $scope.$on('command:UNIVERSAL_OUTPUT', function (event, args) { return ctrl.initComponent(event, args); });
        $scope.$on('workbench:toggle-collapse:right', function () {
            $timeout(triggerResize);
        });
        $scope.$on('workbench:toggle-collapse:left', function () {
            $timeout(triggerResize);
        });
        $scope.$on('universal.schema:done', function (event, args) {
            ctrl.loading.start();
            var _a = ctrl.config, treeName = _a.treeName, currentNode = _a.currentNode, reportOptionString = _a.reportOptionString, excludeTreeFilters = _a.excludeTreeFilters;
            ctrl.schema = args.schema;
            ctrl.isSchemaSaved = args.skipLoadTable;
            ctrl.menu = ctrl.getTableMenu(ctrl.isAdmin, ctrl.isPortfolioAdmin, ctrl.userPrivilege);
            if ('id' in ctrl.schema) {
                ctrl.chartName = ctrl.schema.id + " for " + ctrl.selectedNode.name;
            }
            if (!args.skipLoadTable) {
                ctrl.loadTable(treeName, currentNode._id, ctrl.schema, reportOptionString, excludeTreeFilters);
            }
            else {
                ctrl.loading.end();
            }
        });
    }
    UniversalTableComponent.prototype.getFieldListData = function (treeId, nodeId, schema, packedReportOptions, excludeTreeFilters) {
        return __awaiter(this, void 0, void 0, function () {
            var ctrl, result, packedExcludeTreeFilters, rs, settings, timestamp, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ctrl = this;
                        result = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        packedExcludeTreeFilters = btoa(JSON.stringify(excludeTreeFilters));
                        return [4 /*yield*/, ctrl.smartorgApi.getFieldList(nodeId, schema, packedReportOptions, packedExcludeTreeFilters)];
                    case 2:
                        rs = _a.sent();
                        settings = basic_table_component_1.loadSettings(treeId, rs.settings);
                        ctrl.legends = generateLegends(rs.legends, rs.siblingLegends, rs.data.rows);
                        ctrl.fractionSize = settings.decimals;
                        timestamp = settings.timestampMode === 'lastRecalc' ? ctrl.selectedNode.lastRecalc : null;
                        ctrl.timestamp = basic_table_component_1.getDate(timestamp);
                        result = rs.data;
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        ctrl.showAlert('danger', 'Error!', err_1.message);
                        return [3 /*break*/, 5];
                    case 4:
                        ctrl.loading.end();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/, result];
                }
            });
        });
    };
    UniversalTableComponent.prototype.colorTableAfterSaving = function (colHeaderMap, afterSaveRows, beforeSaveRows, failureList) {
        var failureMap = {};
        failureList.forEach(function (item) {
            failureMap[item.nodeId] = item;
        });
        var red = BG_RED['background-color'];
        var blue = BG_BLUE['background-color'];
        var numOfRows = afterSaveRows.length;
        var _loop_1 = function (i) {
            var arow = afterSaveRows[i];
            var brow = beforeSaveRows[i];
            if (arow.id !== brow.id) {
                throw 'Error! There are some error in data, please contact service provider!';
            }
            var successed = typeof failureMap[arow.id] === 'undefined';
            colHeaderMap.forEach(function (header) {
                var acell = arow[header.key];
                var bcell = brow[header.key];
                if (bcell.style) {
                    // Input, table input or category
                    if (bcell.style['background-color'] === blue) {
                        acell.style = successed ? BG_GREEN : BG_RED;
                    }
                    else if (acell.lookup === 'o' && bcell.style['background-color'] === red) {
                        acell.style = acell.value === bcell.value ? BG_GREEN : BG_RED;
                    }
                    else {
                        acell.style = bcell.style;
                    }
                }
            });
        };
        for (var i = 0; i < numOfRows; i++) {
            _loop_1(i);
        }
    };
    UniversalTableComponent.prototype.processAfterSaving = function (lastChanges, failureList) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, treeName, currentNode, reportOptionString, excludeTreeFilters, fileListData;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.saveComment = '';
                        _b = this.config, treeName = _b.treeName, currentNode = _b.currentNode, reportOptionString = _b.reportOptionString, excludeTreeFilters = _b.excludeTreeFilters;
                        return [4 /*yield*/, this.getFieldListData(treeName, currentNode._id, this.schema, reportOptionString, excludeTreeFilters)];
                    case 1:
                        fileListData = _c.sent();
                        if (fileListData) {
                            this.originalData = fileListData;
                            this.initEditData();
                            this.chartInputData = this.prepareChartInputData();
                            this.colorTableAfterSaving(fileListData.headerMap, fileListData.rows, this.gridOptions.data, failureList);
                            _a = universal_table_grid_1.generateGridOptions(fileListData, this.fractionSize, this.timestamp), this.gridOptions = _a[0], this.hasGroup = _a[1];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    UniversalTableComponent.prototype.initEditData = function () {
        if (this.editMode) {
            this.editData = angular.copy(this.originalData);
            this.formatEditData();
        }
    };
    UniversalTableComponent.prototype.applyExcludeTreeFilter = function (fileListData, excludeTreeFilters) {
        var _this = this;
        var tmpRows = [];
        fileListData.rows.forEach(function (row) {
            if (!_this.checkExcludeFilterNotInRowTags(excludeTreeFilters, row.tags)) {
                if (tmpRows.length == 0) {
                    tmpRows.push(row);
                }
                else if (tmpRows.length > 0 && !(_this.checkRowExists(tmpRows, row))) {
                    tmpRows.push(row);
                }
            }
        });
        fileListData.rows = tmpRows;
    };
    UniversalTableComponent.prototype.checkRowExists = function (tmpRows, row) {
        return tmpRows.some(function (tmpRow) { return tmpRow.id == row.id; });
    };
    UniversalTableComponent.prototype.checkExcludeFilterNotInRowTags = function (excludeTreeFilters, rowTags) {
        return excludeTreeFilters.some(function (excludeFilter) { return rowTags.indexOf(excludeFilter) !== -1; });
    };
    UniversalTableComponent.prototype.loadTable = function (treeId, nodeId, schema, reportOptions, excludeTreeFilters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, fileListData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.editMode = false;
                        return [4 /*yield*/, this.getFieldListData(treeId, nodeId, schema, reportOptions, excludeTreeFilters)];
                    case 1:
                        fileListData = _b.sent();
                        if (excludeTreeFilters && excludeTreeFilters.length > 0) {
                            this.applyExcludeTreeFilter(fileListData, excludeTreeFilters);
                        }
                        this.originalData = fileListData;
                        this.chartInputData = this.prepareChartInputData();
                        _a = universal_table_grid_1.generateGridOptions(fileListData, this.fractionSize, this.timestamp), this.gridOptions = _a[0], this.hasGroup = _a[1];
                        return [2 /*return*/];
                }
            });
        });
    };
    UniversalTableComponent.prototype.initComponent = function (event, args) {
        return __awaiter(this, void 0, void 0, function () {
            var ctrl, i, treeName, rootNodeId, nodeId, _a, userPrivilege, err_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        ctrl = this;
                        ctrl.loading.start();
                        ctrl.gridOptions = {};
                        ctrl.hasGroup = false;
                        ctrl.selectedNode = args.node;
                        ctrl.isAdmin = args.isAdmin;
                        ctrl.isPortfolioAdmin = false;
                        ctrl.isSchemaSaved = true;
                        ctrl.chartType = "line";
                        ctrl.tableOn = true;
                        ctrl.chartOn = false;
                        ctrl.orientation = "horizontal";
                        ctrl.chartRotationIndex = null;
                        ctrl.chartSettings = args.chartSettings;
                        ctrl.chartSettings.showTooltip = ctrl.chartSettings.showTooltip == "true" || ctrl.chartSettings.showTooltip == true;
                        ctrl.chartSettings.showLabels = ctrl.chartSettings.showLabels == "true" || ctrl.chartSettings.showLabels == true;
                        if (args.schema) {
                            for (i = 0; i < args.settings.setChartAsDefault.universalTable.length; i++) {
                                if (args.schema.id === args.settings.setChartAsDefault.universalTable[i]['chartId']) {
                                    ctrl.chartType = args.settings.setChartAsDefault.universalTable[i]['chartType'];
                                    if ('orientation' in args.settings.setChartAsDefault.universalTable[i]) {
                                        ctrl.orientation = args.settings.setChartAsDefault.universalTable[i]['orientation'];
                                    }
                                    if ('chartRotationIndex' in args.settings.setChartAsDefault.universalTable[i]) {
                                        ctrl.chartRotationIndex = args.settings.setChartAsDefault.universalTable[i]['chartRotationIndex'];
                                    }
                                    ctrl.tableOn = false;
                                    ctrl.chartOn = true;
                                }
                            }
                            ctrl.menuID = "UniversalIO:" + args.schema.id;
                        }
                        ctrl.chartName = "Universal Chart for " + ctrl.selectedNode.name;
                        this.failureList = null;
                        this.invalidChanges = null;
                        this.unsavedChanges = null;
                        this.$scope.$root.smartorgDirty = false;
                        treeName = args.rootNode.name;
                        rootNodeId = args.rootNode._id;
                        ctrl.config = {
                            treeName: treeName,
                            currentNode: args.node,
                            reportOptionString: args.reportOptionString,
                            excludeTreeFilters: args.excludeTreeFilters
                        };
                        nodeId = ctrl.selectedNode._id;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 7, , 8]);
                        _a = ctrl;
                        return [4 /*yield*/, this.smartorgApi.categoriesConfigFor(rootNodeId)];
                    case 2:
                        _a.categoryConfig = _b.sent();
                        return [4 /*yield*/, this.smartorgApi.getUserPrivilege(nodeId)];
                    case 3:
                        userPrivilege = _b.sent();
                        ctrl.isPortfolioAdmin = userPrivilege === 3;
                        ctrl.userPrivilege = userPrivilege;
                        ctrl.schema = args.schema || ctrl.schema;
                        if (args.schema && 'id' in args.schema) {
                            ctrl.chartName = args.schema.id + " for " + ctrl.selectedNode.name;
                        }
                        if (!(ctrl.schema && !args.createNew)) return [3 /*break*/, 5];
                        return [4 /*yield*/, ctrl.loadTable(treeName, nodeId, ctrl.schema, args.reportOptionString, args.excludeTreeFilters)];
                    case 4:
                        _b.sent();
                        if (ctrl.tableOn) {
                            ctrl.menu = ctrl.getTableMenu(ctrl.isAdmin, ctrl.isPortfolioAdmin, ctrl.userPrivilege);
                        }
                        else {
                            ctrl.menu = ctrl.getChartMenu();
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        ctrl.loading.end();
                        ctrl.initNewSchema();
                        _b.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        err_2 = _b.sent();
                        ctrl.loading.end();
                        ctrl.showAlert('danger', 'Error!', err_2.message);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    UniversalTableComponent.prototype.exportCsv = function (csvFormat) {
        if (csvFormat === void 0) { csvFormat = undefined; }
        var filename = (this.schema.id || 'UniversalTable') + "_" + this.selectedNode.name + "_" + basic_table_component_1.getDate() + ".csv";
        var csv = universal_table_grid_1.generateCsv(this.originalData, csvFormat);
        var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });
        saveAs(blob, filename);
    };
    UniversalTableComponent.prototype.pasteTable = function ($event) {
        var _a;
        var pastedStuff;
        if ($event.originalEvent &&
            $event.originalEvent.clipboardData &&
            $event.originalEvent.clipboardData.getData) {
            pastedStuff = $event.originalEvent.clipboardData.getData('text/plain');
        }
        else if (window.clipboardData) { // IE
            pastedStuff = window.clipboardData.getData("Text");
        }
        this.iePasteBox = '';
        var _b = this.originalData, grouped = _b.grouped, headerMap = _b.headerMap, rows = _b.rows;
        try {
            var _c = universal_table_paste_1.generateNewTable(headerMap, rows, pastedStuff, this.categoryConfig, this.userPrivilege, this.schema.access.cateContributor), newRows = _c.newRows, changes = _c.changes, invalidChanges = _c.invalidChanges, changedDropdownCategories = _c.changedDropdownCategories;
            _a = universal_table_grid_1.generateGridOptions({ grouped: grouped, headerMap: headerMap, rows: newRows }, this.fractionSize, this.timestamp), this.gridOptions = _a[0], this.hasGroup = _a[1];
            var hasChanges = Object.keys(changes).length > 0;
            this.invalidChanges = invalidChanges;
            this.dropdownCategoryChanges = changedDropdownCategories;
            if (this.invalidChanges.length > 0) {
                this.showAlert('danger', 'Error!', this.invalidChanges[0].message);
            }
            this.unsavedChanges = hasChanges ? changes : null;
            this.$scope.$root.smartorgDirty = hasChanges;
        }
        catch (err) {
            this.showAlert('danger', 'Error!', err.message);
        }
    };
    UniversalTableComponent.prototype.initNewSchema = function () {
        var _this = this;
        this.$timeout(function () {
            _this.$scope.$broadcast('schemaModal:new');
        });
    };
    UniversalTableComponent.prototype.initEditSchema = function () {
        this.$scope.$broadcast('schemaModal:edit');
    };
    UniversalTableComponent.prototype.initDeleteSchema = function () {
        this.$scope.$broadcast('schemaModal:delete');
    };
    UniversalTableComponent.prototype.reset = function () {
        var _a;
        this.initEditData();
        this.invalidChanges = null;
        this.unsavedChanges = null;
        this.$scope.$root.smartorgDirty = false;
        _a = universal_table_grid_1.generateGridOptions(this.originalData, this.fractionSize, this.timestamp), this.gridOptions = _a[0], this.hasGroup = _a[1];
    };
    UniversalTableComponent.prototype.showCommentModal = function () {
        //this.editMode = false;
        if (this.saveComment && this.invalidChanges.length === 0) {
            this.saveChanges();
        }
        else {
            if (!this.saveComment) {
                this.saveComment = 'Changed through universal table.';
            }
            $("#saveInputsCommentModal").modal('show');
        }
    };
    UniversalTableComponent.prototype.getDate = function () {
        var date = new Date().toString();
        var time_split = date.split(" ");
        var time_wo_sec = time_split[4].substring(0, time_split[4].length - 3);
        var time_zone = time_split.slice(6, time_split.length);
        return " - [" + time_split[1] + " " + time_split[2] + " " + time_split[3] + " " + time_wo_sec + " " + time_zone + "]";
    };
    UniversalTableComponent.prototype.saveChanges = function () {
        var _this = this;
        var ctrl = this;
        var treeName = ctrl.config.treeName;
        ctrl.saving = true;
        ctrl.failureList = [];
        var reloadTree = false;
        var unsavedChangesList = Object.values(ctrl.unsavedChanges);
        for (var i = 0; i < unsavedChangesList.length; i++) {
            if ('categories' in unsavedChangesList[i] &&
                JSON.stringify(unsavedChangesList[i]['categories']) !== '{}') {
                reloadTree = true;
                break;
            }
            if (!reloadTree && 'inputs' in unsavedChangesList[i] &&
                JSON.stringify(unsavedChangesList[i]['inputs']) !== '{}') {
                for (var _i = 0, _a = Object.keys(unsavedChangesList[i]['inputs']); _i < _a.length; _i++) {
                    var key = _a[_i];
                    if ('headerMap' in ctrl.originalData) {
                        for (var j = 0; j < ctrl.originalData['headerMap'].length; j++) {
                            if ('lookup' in ctrl.originalData['headerMap'][j] &&
                                ctrl.originalData['headerMap'][j]['lookup'] == 'Inputs' &&
                                key == ctrl.originalData['headerMap'][j]['valKey'] &&
                                ctrl.originalData['headerMap'][j]['type'].indexOf('DROPDOWN') !== -1) {
                                reloadTree = true;
                                break;
                            }
                        }
                    }
                }
            }
        }
        var changesToSave = ctrl.originalData.rows.filter(function (_a) {
            var id = _a.id;
            return id in ctrl.unsavedChanges;
        }).map(function (_a) {
            var id = _a.id;
            return ({ id: id, details: ctrl.unsavedChanges[id] });
        });
        this.handleInputsEndingWithDot(changesToSave);
        ctrl.smartorgApi.universalSaveInputs(treeName, changesToSave, ctrl.saveComment, ctrl.menuID).then(function (res) {
            var lastChanges = ctrl.unsavedChanges;
            var failureList = res.failureList;
            ctrl.$scope.$root.smartorgDirty = false;
            ctrl.unsavedChanges = null;
            ctrl.saving = false;
            ctrl.failureList = failureList.concat(ctrl.invalidChanges);
            if (ctrl.editMode) {
                ctrl.originalData = angular.copy(ctrl.editData);
            }
            // update category data in browser
            var categoriesData = [];
            changesToSave.forEach(function (change) {
                if (Object.keys(change.details.categories).length > 0) {
                    categoriesData.push({ nodeID: change.id, categories: change.details.categories });
                }
            });
            if (categoriesData.length > 0) {
                ctrl.updateCategories(categoriesData);
            }
            if (_this.dropdownCategoryChanges.length > 0) {
                ctrl.updateCategories(_this.dropdownCategoryChanges, "dropdownTags");
            }
            if (failureList && failureList.length > 0) {
                ctrl.$timeout(function () {
                    $("#afterSaveReportModal").modal('show');
                });
            }
            ctrl.processAfterSaving(lastChanges, failureList)["catch"](function (err) {
                throw err;
            });
            ctrl.lastUpdated();
            ctrl.updateNodeIsDataValid(changesToSave, failureList);
            if (reloadTree) {
                ctrl.reloadTree(true);
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
            ctrl.saving = false;
            ctrl.$timeout();
        });
    };
    UniversalTableComponent.prototype.handleInputsEndingWithDot = function (changesToSave) {
        changesToSave.forEach(function (c) {
            var inputsArr = Object.entries(c.details.inputs);
            inputsArr.forEach(function (item) {
                var key = item[0];
                var val = item[1];
                if (typeof val == 'string') { // SCALAR
                    if (val != 'NaN' && val.slice(-1) == '.') {
                        c.details.inputs[key] = val.slice(0, -1);
                    }
                }
                else if (typeof val == 'object') {
                    if (Array.isArray(val)) { // TABLE_INPUT
                        val.forEach(function (ti, idx) {
                            if ('rowHeader' in ti && 'colHeader' in ti &&
                                'value' in ti && ti['value'].slice(-1) == '.') {
                                c.details.inputs[key][idx]['value'] = ti['value'].slice(0, -1);
                            }
                        });
                    }
                    else { // DISTRIBUTION
                        if (0 in val && val[0] != 'NaN' && val[0].slice(-1) == '.') {
                            c.details.inputs[key][0] = val[0].slice(0, -1);
                        }
                        else if (1 in val && val[1] != 'NaN' && val[1].slice(-1) == '.') {
                            c.details.inputs[key][1] = val[1].slice(0, -1);
                        }
                        else if (2 in val && val[2] != 'NaN' && val[2].slice(-1) == '.') {
                            c.details.inputs[key][2] = val[2].slice(0, -1);
                        }
                    }
                }
            });
        });
    };
    UniversalTableComponent.prototype.prepareChartInputData = function () {
        var ctrl = this;
        var chartInputData = [[""]];
        if (ctrl.originalData) {
            for (var i = 0; i < ctrl.originalData.rows.length; i++) {
                chartInputData[0].push(ctrl.originalData.rows[i].name);
            }
            for (var i = 0; i < ctrl.originalData.headerMap.length; i++) {
                if ('lookup' in ctrl.originalData.headerMap[i] &&
                    'constraint' in ctrl.originalData.headerMap[i] &&
                    ctrl.originalData.headerMap[i]['constraint'] != 'string'
                // && (ctrl.originalData.headerMap[i]['type'] == 'SCALAR' ||
                //     ctrl.originalData.headerMap[i]['type'] == 'DISTRIBUTION' ||
                //     ctrl.originalData.headerMap[i]['type'] == 'LIVE')
                ) {
                    var lookup = ctrl.originalData.headerMap[i].lookup;
                    if (lookup == 'Inputs' || lookup == 'Outputs' ||
                        lookup == 'TableInputs' || lookup == 'TableOutputs') {
                        var displayName = ctrl.originalData.headerMap[i].display;
                        chartInputData.push([displayName]);
                        for (var j = 0; j < ctrl.originalData.rows.length; j++) {
                            chartInputData[chartInputData.length - 1].push(Number(ctrl.originalData.rows[j][ctrl.originalData.headerMap[i].key].value));
                        }
                    }
                }
            }
        }
        return chartInputData;
    };
    UniversalTableComponent.prototype.showTables = function () {
        var ctrl = this;
        ctrl.tableOn = true;
        ctrl.chartOn = false;
        ctrl.menu = ctrl.getTableMenu(ctrl.isAdmin, ctrl.isPortfolioAdmin, ctrl.userPrivilege);
    };
    ;
    UniversalTableComponent.prototype.showCharts = function () {
        var ctrl = this;
        ctrl.tableOn = false;
        ctrl.chartOn = true;
        ctrl.menu = ctrl.getChartMenu();
    };
    ;
    UniversalTableComponent.prototype.editView = function () {
        this.editMode = true;
        this.initEditData();
    };
    UniversalTableComponent.prototype.formatEditData = function () {
        var _this = this;
        this.editData.rows.forEach(function (row) {
            var _loop_2 = function (key) {
                var val = row[key];
                if (val && typeof val == 'object' && 'lookup' in val) {
                    if (val['lookup'] == 'i' && val['type'] !== 'DATABASE_DROPDOWN' && val['type'] !== 'DROPDOWN') {
                        if (val['type'] == 'DATE') {
                            val['value'] = val['value'].split(' ');
                        }
                        else if (val['type'] == 'ANCHOREDSCALE') {
                            val['list'] = [];
                            if ('min' in val && 'max' in val) {
                                for (var i = val['min']; i <= val['max']; i++) {
                                    val['list'].push(i);
                                }
                            }
                        }
                        else {
                            if (('constraint' in val && val['constraint'] != 'string') || (!('constraint' in val))) {
                                val['value'] = parseFloat(val['value']);
                            }
                        }
                    }
                    else if (val['lookup'] == 'c') {
                        val['value'] = String(val['value']);
                        _this.categoryConfig.forEach(function (category) {
                            if (category['CategoryName'] == val['key']) {
                                var tmpCategoryEntries = angular.copy(category['CategoryEntries']);
                                tmpCategoryEntries.unshift('');
                                val['categoryEntries'] = tmpCategoryEntries;
                            }
                        });
                    }
                }
            };
            for (var key in row) {
                _loop_2(key);
            }
        });
    };
    UniversalTableComponent.prototype.exitEditView = function () {
        this.editMode = false;
    };
    UniversalTableComponent.prototype.isCellEditable = function (lookup) {
        return lookup == 'i' || lookup == 'ti' || lookup == 'c';
    };
    UniversalTableComponent.prototype.isInputInherited = function (cellData) {
        return typeof (cellData) !== 'string' && 'type' in cellData && 'inherited' in cellData && cellData['inherited'] == true;
    };
    UniversalTableComponent.prototype.isEditableCUnGMF = function (key, row, index) {
        var isEditable = true;
        var ctrl = this;
        var baseYear = 'baseYear' in row ? row['baseYear'] : '';
        var cellData = row[key];
        var columnName = ctrl.originalData.headerMap[index].display;
        if (cellData['lookup'] == 'ti' && cellData['key'] == 'CUnGMFTable') {
            var columnNameSplit = columnName.split('|');
            var year = columnNameSplit[2];
            if (Number(year) == Number(baseYear)) {
                isEditable = false;
            }
        }
        return isEditable;
    };
    UniversalTableComponent.prototype.updateEditUnivTable = function (key, type) {
        var _this = this;
        this.invalidChanges = [];
        this.dropdownCategoryChanges = [];
        this.hasEmptyCell = false;
        this.unsavedChanges = null;
        if (type == 'i') {
            // convert string to float
            this.editData.rows.forEach(function (row) {
                var val = row[key];
                if ((('constraint' in val && val['constraint'] != 'string') || (!('constraint' in val))) &&
                    val && typeof val == 'object' && 'lookup' in val && val['lookup'] == 'i' &&
                    val['type'] !== 'DATABASE_DROPDOWN' && val['type'] !== 'DROPDOWN') {
                    if (val['type'] == 'DATE') {
                        val['value'][1] = val['value'][1].toString().substring(0, 4);
                        var tmpValue = parseFloat(val['value'][1]);
                        val['value'][1] = isNaN(tmpValue) ? 0 : tmpValue;
                    }
                    else {
                        // convert only when string does not end with dot(.)
                        if (typeof val['value'] == 'string' && val['value'].slice(-1) !== '.') {
                            var tmpValue = parseFloat(val['value']);
                            val['value'] = isNaN(tmpValue) ? 0 : tmpValue;
                        }
                        else if (typeof val['value'] == 'string' && val['value'].slice(-1) == '.') {
                            // does not allow more than one dot(.)
                            var idx = val['value'].split('.', 2).join('.').length;
                            var trimmedString = val['value'].substring(0, idx);
                            val['value'] = angular.copy(trimmedString);
                        }
                    }
                }
            });
        }
        //Compare editData & originalData and make 'changes' json
        var changes = {};
        this.editData.rows.forEach(function (editRow) {
            _this.originalData.rows.forEach(function (originalRow) {
                if (editRow['id'] == originalRow['id']) {
                    for (var key_1 in editRow) {
                        var editVal = editRow[key_1];
                        if (editVal && typeof editVal == 'object' && 'lookup' in editVal) {
                            if (editVal['lookup'] == 'i') {
                                if (editVal['value'] == undefined) { // cell content is empty
                                    _this.hasEmptyCell = true;
                                }
                                if (editVal['type'] == 'DATABASE_DROPDOWN' || editVal['type'] == 'DROPDOWN' || editVal['type'] == 'DATE') {
                                    var tmpEditVal = angular.copy(editVal);
                                    tmpEditVal['value'] = tmpEditVal['type'] == 'DATE' ? tmpEditVal['value'][0] + ' ' + tmpEditVal['value'][1] : tmpEditVal['value'];
                                    if (tmpEditVal['value'] !== originalRow[key_1]['value']) {
                                        if (editRow['id'] in changes) {
                                            changes[editRow['id']]['inputs'][tmpEditVal['key']] = tmpEditVal['value'];
                                        }
                                        else {
                                            _this.initValueInChanges(changes, editRow);
                                            changes[editRow['id']]['inputs'][tmpEditVal['key']] = tmpEditVal['value'];
                                        }
                                    }
                                }
                                else {
                                    if ('constraint' in originalRow[key_1] && originalRow[key_1]['constraint'] == 'string' &&
                                        (editVal['value'] !== originalRow[key_1]['value'])) {
                                        if (editRow['id'] in changes) {
                                            _this.setInputValueInEditMode(editVal, changes, editRow, key_1);
                                        }
                                        else {
                                            _this.initValueInChanges(changes, editRow);
                                            _this.setInputValueInEditMode(editVal, changes, editRow, key_1);
                                        }
                                    }
                                    else if (!isNaN(parseFloat(editVal['value'])) &&
                                        !isNaN(parseFloat(originalRow[key_1]['value'])) &&
                                        (editVal['value'] !== parseFloat(originalRow[key_1]['value']))) {
                                        if (editRow['id'] in changes) {
                                            _this.setInputValueInEditMode(editVal, changes, editRow, key_1);
                                        }
                                        else {
                                            _this.initValueInChanges(changes, editRow);
                                            _this.setInputValueInEditMode(editVal, changes, editRow, key_1);
                                        }
                                    }
                                }
                            }
                            else if (editVal['lookup'] == 'ti') {
                                if (editVal['value'].toString() !== originalRow[key_1]['value'].toString()) {
                                    if (editRow['id'] in changes) {
                                        var changedTableInput = _this.getChangedTableInput(key_1, editVal);
                                        if (changedTableInput) {
                                            if (editVal['key'] in changes[editRow['id']]['inputs']) {
                                                changes[editRow['id']]['inputs'][editVal['key']].push(changedTableInput);
                                            }
                                            else {
                                                changes[editRow['id']]['inputs'][editVal['key']] = [changedTableInput];
                                            }
                                        }
                                    }
                                    else {
                                        _this.initValueInChanges(changes, editRow);
                                        var changedTableInput = _this.getChangedTableInput(key_1, editVal);
                                        if (changedTableInput) {
                                            changes[editRow['id']]['inputs'][editVal['key']] = [changedTableInput];
                                        }
                                    }
                                }
                            }
                            else if (editVal['lookup'] == 'c') {
                                if (editVal['value'] !== originalRow[key_1]['value']) {
                                    if (editRow['id'] in changes) {
                                        changes[editRow['id']]['categories'][editVal['key']] = editVal['value'];
                                    }
                                    else {
                                        _this.initValueInChanges(changes, editRow);
                                        changes[editRow['id']]['categories'][editVal['key']] = editVal['value'];
                                    }
                                }
                            }
                        }
                    }
                }
            });
        });
        var hasChanges = Object.keys(changes).length > 0;
        if (!this.hasEmptyCell) {
            this.unsavedChanges = hasChanges ? changes : null;
            this.$scope.$root.smartorgDirty = hasChanges;
        }
    };
    UniversalTableComponent.prototype.getChangedTableInput = function (key, editVal) {
        for (var i = 0; i < this.originalData.headerMap.length; i++) {
            if (this.originalData.headerMap[i]['key'] == key) {
                return {
                    'rowHeader': this.originalData.headerMap[i]['rowHeader'],
                    'colHeader': this.originalData.headerMap[i]['colHeader'],
                    'value': isNaN(editVal['value']) ? editVal['value'] : editVal['value']
                };
            }
        }
        return null;
    };
    UniversalTableComponent.prototype.initValueInChanges = function (changes, editRow) {
        changes[editRow['id']] = {
            'nodeName': editRow['name'],
            'inputs': {},
            'categories': {}
        };
    };
    UniversalTableComponent.prototype.setInputValueInEditMode = function (editVal, changes, editRow, key) {
        if ('value' in editVal) {
            var valueToSave = editVal['value'].toString();
            if (editVal['type'] !== 'DISTRIBUTION') {
                changes[editRow['id']]['inputs'][editVal['key']] = valueToSave;
            }
            else {
                if (key.split('|').pop() == 'Low') {
                    if (editVal['key'] in changes[editRow['id']]['inputs']) {
                        changes[editRow['id']]['inputs'][editVal['key']]['0'] = valueToSave;
                    }
                    else {
                        changes[editRow['id']]['inputs'][editVal['key']] = { '0': valueToSave };
                    }
                }
                else if (key.split('|').pop() == 'Base') {
                    if (editVal['key'] in changes[editRow['id']]['inputs']) {
                        changes[editRow['id']]['inputs'][editVal['key']]['1'] = valueToSave;
                    }
                    else {
                        changes[editRow['id']]['inputs'][editVal['key']] = { '1': valueToSave };
                    }
                }
                else if (key.split('|').pop() == 'High') {
                    if (editVal['key'] in changes[editRow['id']]['inputs']) {
                        changes[editRow['id']]['inputs'][editVal['key']]['2'] = valueToSave;
                    }
                    else {
                        changes[editRow['id']]['inputs'][editVal['key']] = { '2': valueToSave };
                    }
                }
            }
        }
    };
    UniversalTableComponent.prototype.getTableMenu = function (isAdmin, isPortfolioAdmin, userPrivilege) {
        var ctrl = this;
        var menu = [{
                'name': 'Export',
                'items': [{
                        'name': 'Table',
                        'callback': function () {
                            ctrl.exportCsv();
                        }
                    }, {
                        'name': 'Table EU',
                        'callback': function () {
                            ctrl.exportCsv('EU');
                        }
                    }]
                // }, {
                //     'name': 'Edit',
                //     'class': 'btn btn-xs btn-primary',
                //     'show': () => {
                //         return userPrivilege > 1 && !ctrl.unsavedChanges && !ctrl.saving && !ctrl.editMode;
                //     },
                //     'callback': () => {
                //         ctrl.editView();
                //     }
                // },{
                //     'name': 'Done',
                //     'class': 'btn btn-xs btn-primary',
                //     'show': () => {
                //         return userPrivilege > 1 && !ctrl.unsavedChanges && !ctrl.saving && ctrl.editMode;
                //     },
                //     'callback': () => {
                //         ctrl.exitEditView();
                //     }
            }, {
                'name': 'Save',
                'class': 'btn btn-xs btn-danger',
                'show': function () {
                    return userPrivilege > 1 && ctrl.unsavedChanges && !ctrl.saving;
                },
                'callback': function () {
                    ctrl.showCommentModal();
                }
            }, {
                'name': 'Reset',
                'class': 'btn btn-xs btn-primary',
                'show': function () {
                    return (ctrl.unsavedChanges && !ctrl.saving) ||
                        (ctrl.invalidChanges !== null && ctrl.invalidChanges.length > 0);
                },
                'callback': function () {
                    ctrl.reset();
                }
            }, {
                'name': '',
                'class': 'btn btn-xs btn-danger',
                'icon': 'fa fa-spinner fa-spin fa-fw',
                'show': function () {
                    return ctrl.saving;
                }
            }, {
                'name': 'Report',
                'class': 'btn btn-xs btn-info',
                'show': function () {
                    return ctrl.failureList && !ctrl.saving;
                },
                'callback': function () {
                    $("#afterSaveReportModal").modal('show');
                }
            }, {
                'name': '',
                'class': 'fa fa-question-circle',
                'show': function () { return true; },
                'callback': function () { return $("#helpModal").modal('show'); }
            }];
        if (ctrl.isIOPresentInSchema()) {
            menu.unshift({
                'name': 'Display',
                'items': [{
                        'name': 'Chart',
                        'callback': function () {
                            ctrl.showCharts();
                        }
                    }]
            });
            if (ctrl.userPrivilege === 3 && 'id' in ctrl.schema) {
                menu[0]['items'].push({
                    'name': 'Set as Default',
                    'callback': function () {
                        ctrl.setChartAsDefault('table');
                    }
                });
            }
        }
        if ((isAdmin || userPrivilege > 2) && (ctrl.isSchemaSaved)) {
            var settingMenu = {
                'name': 'Settings',
                'show': function () {
                    return ctrl.schema;
                },
                'items': [{
                        'name': 'Edit Table',
                        'callback': function () {
                            ctrl.initEditSchema();
                        }
                    }]
            };
            if (isAdmin || isPortfolioAdmin) {
                settingMenu.items.push({
                    'name': 'Delete Table',
                    'callback': function () {
                        ctrl.initDeleteSchema();
                    }
                });
            }
            menu.splice(1, 0, settingMenu);
        }
        return menu;
    };
    UniversalTableComponent.prototype.isIOPresentInSchema = function () {
        var ctrl = this;
        var result = true;
        if (ctrl.schema) {
            var a = Object.keys(ctrl.schema.templates);
            for (var i = 0; i < a.length; i++) {
                if (ctrl.schema.templates[a[i]].leaf.inputKeys === undefined) {
                    delete ctrl.schema.templates[a[i]].leaf.inputKeys;
                }
                if (ctrl.schema.templates[a[i]].leaf.outputKeys === undefined) {
                    delete ctrl.schema.templates[a[i]].leaf.outputKeys;
                }
                if ((Object.keys(ctrl.schema.templates[a[i]].leaf.inputTables).length === 0) &&
                    (Object.keys(ctrl.schema.templates[a[i]].leaf.outputTables).length === 0) &&
                    !('inputKeys' in ctrl.schema.templates[a[i]].leaf) &&
                    !('outputKeys' in ctrl.schema.templates[a[i]].leaf)) {
                    result = false;
                    break;
                }
            }
        }
        return result;
    };
    UniversalTableComponent.prototype.exportCharts = function () {
        var exporter = new smartorg.r6.lib.ChartExporter("chart", "svg-canvas");
        var chartName = (this.schema.id || 'UniversalTableChart') + "_" + this.selectedNode.name + "_" + basic_table_component_1.getDate() + ".csv";
        exporter.exportChart(chartName, true);
    };
    ;
    UniversalTableComponent.prototype.setChartAsDefault = function (chartBy) {
        var ctrl = this;
        var treeName = ctrl.config.treeName;
        ctrl.smartorgApi.setChartAsDefault(treeName, ctrl.schema.id, "universalTable", chartBy, ctrl.chartType, ctrl.orientation, ctrl.chartRotationIndex).then(function (res) {
            console.log(res);
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    UniversalTableComponent.prototype.getChartMenu = function () {
        var ctrl = this;
        var chartMenu = [
            {
                'name': 'Display',
                'items': [{
                        'name': 'Table',
                        'callback': function () {
                            ctrl.showTables();
                        }
                    }]
            }, {
                'name': 'Export',
                'items': [{
                        'name': 'Chart',
                        'callback': function () {
                            ctrl.exportCharts();
                        }
                    }]
            }
        ];
        if (ctrl.userPrivilege === 3 && 'id' in ctrl.schema) {
            chartMenu[0]['items'].push({
                'name': 'Set as Default',
                'callback': function () {
                    ctrl.setChartAsDefault(null);
                }
            });
        }
        return chartMenu;
    };
    UniversalTableComponent = __decorate([
        basic_table_component_1.Component({
            bindings: {
                smartorgApi: '=',
                menu: '='
            },
            template: require('./universal-table.component.html')
        }),
        __metadata("design:paramtypes", [Object, Object])
    ], UniversalTableComponent);
    return UniversalTableComponent;
}());
angular.module('smartorg.r6.acts.universal.table', [
    require('../schema-builder/app/js/plumbing/app'),
    require('../schema-modals/schema-modals.component'),
    require('../universal-chart/universal-chart.component'),
    'ui.grid',
    'ui.grid.pinning',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.moveColumns',
    'ui.grid.grouping'
]).component('universalTable', UniversalTableComponent).filter('numberToFixed', function () {
    return function (val, fractionSize) {
        var a = parseFloat(val);
        return isNaN(a) ? val : a.toFixed(fractionSize);
    };
}).filter('whiteSapce', function () {
    return function (val) {
        return val.replace(/\s/g, '_');
    };
});
module.exports = 'smartorg.r6.acts.universal.table';
//# sourceMappingURL=universal-table.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/universal-io/app/universal-table2/universal-table.component.js